/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2, VisuallyHidden } from '@coursera/cds-core';

import type { ErrorTree } from 'bundles/assess-common/types/ErrorTree';
import type { ValidationError } from 'bundles/assess-common/types/ValidationErrors';

const styles = {
  errorContainer: () => css`
    background-color: var(--cds-color-feedback-background-error-weak);
    border-radius: var(--cds-spacing-50);
    padding: var(--cds-spacing-50) var(--cds-spacing-100);
    margin-bottom: var(--cds-spacing-150);
  `,
};

type Props = {
  id?: string;
  errorTree?: ErrorTree;
  validationError?: ValidationError | null;
};

const InlineValidationErrorV2 = ({ id, errorTree, validationError }: Props) => {
  if ((validationError && validationError.debugMessage) || (errorTree && errorTree.errors.length > 0)) {
    let errorMsg = '';
    if (validationError && validationError.debugMessage) {
      errorMsg = validationError.debugMessage;
    } else if (errorTree && errorTree.errors.length > 0) {
      errorMsg = errorTree.errors.map((error) => error.errorMessage).join(' ');
    }

    return (
      <div css={styles.errorContainer}>
        <Typography2 aria-hidden color="error" component="span" variant="subtitleMedium">
          {errorMsg}
        </Typography2>
        <VisuallyHidden role="alert" id={id} aria-live="assertive" component="span" className="rc-A11yScreenReaderOnly">
          Error: {errorMsg}
        </VisuallyHidden>
      </div>
    );
  }
  return null;
};

export default InlineValidationErrorV2;
